import {
  SuppliersResponseModel,
  SupplierApiModel,
} from './../models/suppliers.model';
import { Injectable } from '@angular/core';
import { MwHttpService } from '@core/http';
import { MwLoadOptionsService } from './utils/load-options.service';
import { MwLoadOptions } from 'app/models/load-options.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MwSuppliersApiService {
  constructor(
    private http: MwHttpService,
    private loadOptionsService: MwLoadOptionsService
  ) {}

  load(options?: MwLoadOptions): Observable<SuppliersResponseModel> {
    let query = options ? this.loadOptionsService.buildQuery(options) : '';
    query = query.length ? `?${query}` : query;
    return this.http.authGet<SuppliersResponseModel>(
      `/transport/v1/Companies/{companyId}/Suppliers${query}`
    );
  }

  create(supplier: SupplierApiModel): Observable<SupplierApiModel> {
    return this.http.authPost<SupplierApiModel>(
      `/transport/v1/Companies/{companyId}/Suppliers`,
      {
        body: supplier,
      }
    );
  }

  update(supplier: SupplierApiModel): Observable<SupplierApiModel> {
    return this.http.authPut<any>(
      `/transport/v1/Companies/{companyId}/Suppliers`,
      {
        body: supplier,
      }
    );
  }

  delete(supplier: SupplierApiModel): Observable<SupplierApiModel> {
    return this.http.authDelete<SupplierApiModel>(
      `/transport/v1/Companies/{companyId}/Suppliers`,
      {
        body: supplier,
      }
    );
  }

  deleteList(supplier: SupplierApiModel[]): Observable<SupplierApiModel> {
    return this.http.authDelete<any>(
      `/transport/v1/Companies/{companyId}/Suppliers/All`,
      {
        body: supplier,
      }
    );
  }
}
